export default __webpack_public_path__ + "static/media/phone.ace115f4.svg";